import { TCreateModifierGroupsAction, CreateModifierGroupsActionTypes } from './createModifierGroupsActions';
import { ICreateModifierGroupsState } from './createModifierGroupsContext';

export const createModifierGroupsReducer = (
	state: ICreateModifierGroupsState,
	action: TCreateModifierGroupsAction,
): ICreateModifierGroupsState => {
	switch (action.type) {
		case CreateModifierGroupsActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case CreateModifierGroupsActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.customers,
			};
		case CreateModifierGroupsActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				fetchedRestaurants: [],
				IDsSelectedRestaurant: [],
				fetchedCategories: [],
				IDsSelectedCategories: [],
				fetchedSubcategories: [],
				IDsSelectedSubcategories: [],
				fetchedDishes: [],
				IDsSelectedDishes: [],
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
			};
		case CreateModifierGroupsActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.restaurants,
			};
		case CreateModifierGroupsActionTypes.SET_IDS_RESTAURANT:
			return {
				...state,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
			};
		case CreateModifierGroupsActionTypes.SET_FETCHED_CATEGORIES:
			return {
				...state,
				fetchedCategories: action.payload.fetchedCategories,
			};
		case CreateModifierGroupsActionTypes.SET_IDS_CATEGORIES:
			return {
				...state,
				IDsSelectedCategories: action.payload.IDsSelectedCategories,
			};
		case CreateModifierGroupsActionTypes.SET_FETCHED_SUBCATEGORIES:
			return {
				...state,
				fetchedSubcategories: action.payload.fetchedSubcategories,
			};
		case CreateModifierGroupsActionTypes.SET_IDS_SUBCATEGORIES:
			return {
				...state,
				IDsSelectedSubcategories: action.payload.IDsSelectedSubcategories,
			};
		case CreateModifierGroupsActionTypes.SET_FETCHED_DISHES:
			return {
				...state,
				fetchedDishes: action.payload.dishes,
			};
		case CreateModifierGroupsActionTypes.SET_IDS_DISHES:
			return {
				...state,
				IDsSelectedDishes: action.payload.IDsSelectedDishes,
			};
		case CreateModifierGroupsActionTypes.CHANGE_NAME_OF_MODIFIER_GROUP:
			return {
				...state,
				nameOfModifierGroup: action.payload.nameOfModifierGroup,
			};
		case CreateModifierGroupsActionTypes.SET_FETCHED_TRANSLATIONS:
			return {
				...state,
				translations: action.payload.translations,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case CreateModifierGroupsActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case CreateModifierGroupsActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case CreateModifierGroupsActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateModifierGroupsActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateModifierGroupsActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
			};
		case CreateModifierGroupsActionTypes.RESET_FIELDS:
			return {
				...state,
				fetchedCustomers: [],
				IDSelectedCustomer: null,
				fetchedRestaurants: [],
				IDsSelectedRestaurant: [],
				fetchedCategories: [],
				IDsSelectedCategories: [],
				fetchedSubcategories: [],
				IDsSelectedSubcategories: [],
				fetchedDishes: [],
				IDsSelectedDishes: [],
				nameOfModifierGroup: '',
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
				dataForSubmit: null,
				typeOfModalWindow: null,
				errorResponseData: null,
			};
		default:
			return state;
	}
};
